import { render, staticRenderFns } from "./RegisterAnomynous.vue?vue&type=template&id=959ffa1a&scoped=true"
import script from "./RegisterAnomynous.vue?vue&type=script&lang=js"
export * from "./RegisterAnomynous.vue?vue&type=script&lang=js"
import style0 from "./RegisterAnomynous.vue?vue&type=style&index=0&id=959ffa1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959ffa1a",
  null
  
)

export default component.exports